<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title title">Add New User</p>
    </header>
    <div>
      <section class="modal-card-body">
        <div class="user-info">
            <b-field label="First Name" class="mr">
                <b-input v-model="formData.firstName" type="text"></b-input>
            </b-field>
            <b-field label="Last Name">
                <b-input v-model="formData.lastName" type="text"></b-input>
            </b-field>
        </div>
        <div class="user-info">
            <b-field label="Middle Name" class="mr">
                <b-input v-model="formData.middleName" type="text"></b-input>
            </b-field>
            <b-field label="User name">
                <b-input v-model="formData.username" type="text"></b-input>
            </b-field>
        </div>
       <b-field label="Email">
          <b-input v-model="formData.email" type="text">
          </b-input>
        </b-field>
       <b-field label="Role">
            <b-select v-model="formData.role" placeholder="Select a character" expanded>
                <option value="manager">Manager</option>
                <option value="basic">Basic</option>
            </b-select>
        </b-field>
        <b-field v-if="formData.role && formData.role.toLowerCase() === 'basic'" label="Facilty">
            <b-select v-model="formData.facilityId" placeholder="Select a character" expanded>
                <option
                    v-for="option in filteredFacility"
                    :value="option.id"
                    :key="option.id">
                    {{ option.facility_name }}
                </option>
            </b-select>
        </b-field>
        <b-field label="Phone Number">
          <b-input v-model="formData.phoneNumber" type="number">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button cancel" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button class="button btn" @click="submit">Save</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'AddUserModal',
  props: [
    'companyIdOfLoggedUser',
    'facility'
  ],
  data() {
    return {
      isAddModalActive: false,
      formData: {
        companyId: this.companyIdOfLoggedUser // company id of logged user
      }
    };
  },
  computed: {
    ...mapGetters(['getStatus']),
    filteredFacility() {
      return this.facility;
    }
  },
  watch: {
    getStatus(val) {
      if (val === 'success') {
        this.$parent.close();
      }
    }
  },
  methods: {
    ...mapActions('apps', ['addNewUser']),
    submit() {
      this.addNewUser(this.formData);
    }
  }
};
</script>

<style>
.modal-card {
  width: 30vw !important;
}
.user-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.mr {
    margin-right: 10px;
}
.field {
  display: flex;
  /* flex-direction: column; */
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 26px;
  line-height: 26px;
  color: #000000;
}
.label {
  margin-bottom: 20px;
  width: 100% !important;
}
.control{
  width: 100%;
}
.modal-card-body {
  padding: 1.5rem 40px;
}
.modal-card-foot {
  padding: 20px 40px;
  display: flex;
  justify-content: flex-end;
}
.error {
  color: red;
  font-size: 14px;
}
.cancel {
  background: transparent;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 13px;
  color: #5051DB;
}
.btn {
  background: #3887F6;
  color: #ffffff;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  padding: 20px 40px;
}
@media screen and (max-width: 768px) {
  .modal-card {
    width: 90vw !important;
  }
}
</style>
